(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('[data-dropdown-toggle]');
    let openDropdown = null;

    // Function to close dropdown
    function closeDropdown(dropdown) {
      if (!dropdown) return;

      const toggle = dropdown.querySelector('[data-dropdown-toggle]');
      const menu = dropdown.querySelector('.dropdown-menu');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('bg-highlight');
      }
      if (menu) menu.classList.add('hidden');

      openDropdown = null;
    }

    // Function to open dropdown
    function openDropdownMenu(dropdown) {
      if (openDropdown && openDropdown !== dropdown) {
        closeDropdown(openDropdown);
      }

      const toggle = dropdown.querySelector('[data-dropdown-toggle]');
      const menu = dropdown.querySelector('.dropdown-menu');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('bg-highlight');
      }
      if (menu) menu.classList.remove('hidden');

      openDropdown = dropdown;
    }

    // Function to close submenu
    function closeSubmenu(submenu) {
      if (!submenu) return;

      const toggle = submenu.querySelector('[data-submenu-toggle]');
      const menu = submenu.querySelector('.submenu');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('bg-highlight');
      }
      if (menu) menu.classList.add('hidden');

      openSubmenu = null;
    }

    // Function to open submenu
    function openSubmenuMenu(submenu) {
      if (openSubmenu && openSubmenu !== submenu) {
        closeSubmenu(openSubmenu);
      }

      const toggle = submenu.querySelector('[data-submenu-toggle]');
      const menu = submenu.querySelector('.submenu');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('bg-highlight');
      }
      if (menu) menu.classList.remove('hidden');

      openSubmenu = submenu;
    }

    // Add click event listeners to dropdown toggles
    dropdownToggles.forEach((toggle) => {
      const dropdown = toggle.closest('.dropdown-container');

      toggle.addEventListener('click', function (e) {
        e.preventDefault();

        if (toggle.getAttribute('aria-expanded') === 'true') {
          closeDropdown(dropdown);
        } else {
          openDropdownMenu(dropdown);
        }
      });

      // Handle mouseover for desktop users
      dropdown.addEventListener('mouseover', function () {
        openDropdownMenu(dropdown);
      });

      dropdown.addEventListener('mouseout', function (e) {
        if (!dropdown.contains(e.relatedTarget)) {
          closeDropdown(dropdown);
        }
      });
    });

    // Add click event listeners to submenu toggles
    // submenuToggles.forEach((toggle) => {
    //   const submenu = toggle.closest('.submenu-container');

    //   toggle.addEventListener('click', function (e) {
    //     e.preventDefault();

    //     if (toggle.getAttribute('aria-expanded') === 'true') {
    //       closeSubmenu(submenu);
    //     } else {
    //       openSubmenuMenu(submenu);
    //     }
    //   });
    // });

    // Handle keyboard navigation
    document.addEventListener('keydown', function (event) {
      // Close dropdown with Escape key
      if (event.key === 'Escape') {
        // if (openSubmenu) {
        //   closeSubmenu(openSubmenu);
        //   return;
        // }

        if (openDropdown) {
          closeDropdown(openDropdown);
          return;
        }
      }

      // Handle tabbing out of dropdown/submenu
      if (event.key === 'Tab' && openDropdown) {
        setTimeout(() => {
          const activeDropdown = openDropdown ? openDropdown.contains(document.activeElement) : false;
          // const activeSubmenu = openSubmenu ? openSubmenu.contains(document.activeElement) : false;

          if (!activeDropdown && openDropdown) {
            closeDropdown(openDropdown);
          }

          // if (!activeSubmenu && openSubmenu) {
          //   closeSubmenu(openSubmenu);
          // }
        }, 0);
      }
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (e) {
      if (openDropdown && !openDropdown.contains(e.target)) {
        closeDropdown(openDropdown);
      }

      // if (openSubmenu && !openSubmenu.contains(e.target)) {
      //   closeSubmenu(openSubmenu);
      // }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
